import {baseSelector, useSliceDispatch} from "../../utils";
import {PlayerActions} from "./actions";
import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {PlayerSliceState} from "./reducers";
import {useSelector} from "react-redux";

// type PlayerDispatch = PlayerActions;
export const usePlayerDispatch = () => useSliceDispatch<PlayerActions>();

export const selectPlayerSlice = createSelector(
    [
        (state: RootState) => state.player,
        (state: RootState, keys: (keyof PlayerSliceState)[]) => keys
    ],
    (slice, keys) => baseSelector(slice, keys)() // Call the baseSelector function here to get the selected props
);

export const usePlayerSelector = (keys: (keyof PlayerSliceState)[]) => {
    return useSelector((state: RootState) => selectPlayerSlice(state, keys));
}


